<template>
    <comp-4-goal-blurbs :section="7" :page="10" :blurbs="goalBlurbs"></comp-4-goal-blurbs>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        goalBlurbs: get('section7/goalBlurbs')
    }
};
</script>
